"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonUtil = void 0;
const TypeGuards_1 = require("./TypeGuards");
class JsonUtil {
    /**
     * method that cleans up any empty values or empty nested objects
     * looks at each attribute on an object and checks if it is empty, undefined, null, or NaN
     * looks at an object and identifies if it is empty to be removed
     * @param obj - object to be cleaned of empty values or empty nested objects
     * @returns object that has removed any empty values or empty nested objects
     */
    static pruneEmpty(obj) {
        if (obj === undefined) {
            return obj;
        }
        return (function prune(current) {
            for (const [key, value] of Object.entries(current)) {
                if (TypeGuards_1.TypeGuards.isUndefined(value) ||
                    TypeGuards_1.TypeGuards.isNull(value) ||
                    TypeGuards_1.TypeGuards.isNaN(value) ||
                    (TypeGuards_1.TypeGuards.isString(value) && TypeGuards_1.TypeGuards.isNullOrWhiteSpace(value)) ||
                    (TypeGuards_1.TypeGuards.isObject(value) && TypeGuards_1.TypeGuards.isEmpty(prune(value)))) {
                    delete current[key];
                }
            }
            // remove any leftover undefined values from the delete
            // operation on an array
            let localCurrent = current;
            if (Array.isArray(localCurrent)) {
                localCurrent = localCurrent.filter((x) => x !== undefined);
            }
            return localCurrent;
        })(TypeGuards_1.TypeGuards.cloneDeep(obj)); // Do not modify the original object, create a clone instead
    }
}
exports.JsonUtil = JsonUtil;
//# sourceMappingURL=JsonUtil.js.map